export default __webpack_public_path__ + "0d913f4741f4ed9bc9dc30430841db32.jpg";